import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Label,
  Textarea,
} from '@planuze/ui';
import { type ReactNode, useEffect, useState } from 'react';
import { useCommonContent } from '../content/sections/common.js';

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly title: string;
  readonly description: string;
  readonly confirmLabel: string;
  readonly reasonLabel: string;
  readonly destructive?: boolean;
  readonly pending: boolean;
  readonly validate: (reason: string) => boolean;
  readonly onConfirm: (reason: string) => void;
  /** Campos extra acima do motivo (ex.: horas de cooldown, picker de destino). */
  readonly children?: ReactNode;
}

/* Modal de motivo genérico p/ ações do backoffice (ADR-0355/0356). `locked` enquanto
   pendente (ADR-0216); reseta ao fechar. `children` permite campos extras. */
export function ReasonDialog(props: Props) {
  const {
    open,
    onClose,
    title,
    description,
    confirmLabel,
    reasonLabel,
    destructive,
    pending,
    validate,
    onConfirm,
    children,
  } = props;
  const [reason, setReason] = useState('');
  const copy = useCommonContent().reasonDialog;

  useEffect(() => {
    if (!open) setReason('');
  }, [open]);

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next && !pending) onClose();
      }}
    >
      <DialogContent locked={pending}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        {children}
        <div className="space-y-1.5">
          <Label htmlFor="reason-dialog-reason">{reasonLabel}</Label>
          <Textarea
            id="reason-dialog-reason"
            rows={3}
            maxLength={500}
            value={reason}
            placeholder={copy.placeholder}
            onChange={(e) => setReason(e.target.value)}
          />
          <p className="text-xs text-muted-foreground">{copy.characterCount(reason.length)}</p>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} disabled={pending}>
            {copy.cancel}
          </Button>
          <Button
            variant={destructive === true ? 'destructive' : 'default'}
            loading={pending}
            disabled={!validate(reason)}
            onClick={() => onConfirm(reason)}
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
